module.exports = __webpack_public_path__ + "static/media/ddbh.0333d413.svg";